import { useEffect, useState } from "react";

// True once the #loader element has been marked done by Loader.js
// (it adds class="remove" when its fade-out completes).
export const useLoaderDone = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const loader = document.getElementById("loader");
    if (!loader) {
      setDone(true);
      return;
    }
    if (loader.classList.contains("remove")) {
      setDone(true);
      return;
    }
    const observer = new MutationObserver(() => {
      if (loader.classList.contains("remove")) {
        setDone(true);
        observer.disconnect();
      }
    });
    observer.observe(loader, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  return done;
};
